import type { TFunction } from 'i18next'

import { ApiError } from './api'

/**
 * Sunucu hatasini KULLANICININ DILINDE metne cevirir.
 *
 * ## Neden `code`, mesaj degil
 *
 * Sunucu mesajlari cevrilmiyor ve cevrilmemeli: hata metinleri log'a,
 * denetim kaydina ve destek konusmalarina giriyor - orada tek dil olmasi
 * dogru. Ama arayuz Ingilizce'yken Turkce bir hata gostermek de kabul
 * edilemez. Cozum sunucunun ZATEN uretttigi kaba kod: `invalid_credentials`,
 * `storage_quota_exceeded` gibi.
 *
 * (Bu kodlar bir sure govdeye HIC ulasmiyordu: cagri yerleri
 * `HTTPException(detail=exc.message)` yaziyor ve `.code`u dusuruyordu.
 * Sunucu tarafinda `coded_detail()` ile duzeltildi.)
 *
 * ## Katman sirasi
 *
 * 1. `ApiError` degil -> ag hatasi (istek sunucuya HIC ulasmadi).
 * 2. 423/429 -> bekleme suresi mesaja KATILIYOR. Bunlar koddan once:
 *    "ne kadar bekleyecegim" bilgisi kodun kendisinden daha degerli.
 * 3. `error.<code>` anahtari varsa o.
 * 4. Son care: sunucu mesaji (Turkce). Cevrilmemis bir kod ekranda bos
 *    veya ham anahtar olarak GORUNMEMELI - eksik ceviri, hatanin
 *    kaybolmasindan iyidir.
 */
export function describeApiError(cause: unknown, t: TFunction): string {
  if (!(cause instanceof ApiError)) return t('auth.error.network')

  if (cause.status === 423 && cause.retryAfter) {
    return t('auth.error.lockedRetry', {
      message: translateCode(cause, t) ?? cause.message,
      minutes: Math.ceil(cause.retryAfter / 60),
    })
  }
  if (cause.status === 429 && cause.retryAfter) {
    return t('auth.error.tooManyRetry', { seconds: cause.retryAfter })
  }

  return translateCode(cause, t) ?? cause.message
}

/** Kodun cevirisi varsa dondurur, yoksa `null`. */
export function translateCode(cause: ApiError, t: TFunction): string | null {
  if (!cause.code) return null
  // `defaultValue: ''` sart: i18next varsayilan olarak ANAHTARIN KENDISINI
  // donduruyor, yani kontrol etmeden kullanmak ekranda
  // `error.storage_quota_exceeded` gostermek olurdu.
  const translated = t(`error.${cause.code}`, { defaultValue: '' })
  return translated || null
}
